import { useParams } from "react-router-dom";
import { shippingCartons } from "../ShippingCartons";
import ProductWithBOM from "./ProductWithBOM";
import ProductWithoutBOM from "./ProductWithoutBOM";

const ProductCostDetailView = ({ product }) => {
  const { company } = useParams();

  const cartonCostPerUnit = shippingCartons.map((carton) => {
    const costPerUnit = (
      (product.outerCartonCbm / product.quantityPerCarton / carton.maxCbm) *
      carton.cost
    ).toFixed(3);
    return { ...carton, costPerUnit };
  });

  const hasBom = product.children.length > 0;

  return (
    <div>
      <h5>
        #{product.id} [{product.number}] {product.name}
      </h5>

      {hasBom ? (
        <ProductWithBOM product={product} company={company} />
      ) : (
        <ProductWithoutBOM
          product={product}
          qty={product.defaultQty}
          company={company}
        />
      )}

      {company === "AB" && (
        <div className="mt-4">
          <h4>FOB Cost</h4>

          <div className="flex space-x-8">
            <div className="flex space-x-4">
              <div>
                <label className="pr-2">Quantity / Carton:</label>
                {product.quantityPerCarton}
              </div>
              <div>
                <label className="pr-2">Outer Carton CBM:</label>
                {product.outerCartonCbm} m³
              </div>
            </div>
            <div className="space-x-6 flex">
              {cartonCostPerUnit.map((i, index) => (
                <div key={index} className="flex space-x-2 items-center">
                  <label>{i.name}: </label>
                  <div>${i.costPerUnit}</div>
                </div>
              ))}
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default ProductCostDetailView;
